import { render, staticRenderFns } from "./Procurements.vue?vue&type=template&id=6609baec&scoped=true"
import script from "./Procurements.vue?vue&type=script&lang=js"
export * from "./Procurements.vue?vue&type=script&lang=js"
import style0 from "./Procurements.vue?vue&type=style&index=0&id=6609baec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6609baec",
  null
  
)

export default component.exports